import { styled } from '@mui/material';
import { Box } from '@mui/system';

export const StyledDaysCalendarWrap = styled(Box)(() => ({
	display: 'grid',
	gap: '8px',
	gridTemplateColumns: '1fr',
}));
